import '@/css/main.css'
import { createApp } from 'vue'
import i18n from './i18n/i18n'
import App from './App.vue'
import router from './router'
import store from './store'
import { VueHeadMixin, createHead } from '@unhead/vue'
import paywall from './directives/paywall'

const head = createHead()
createApp(App).use(store).use(router).use(i18n).use(head).mixin(VueHeadMixin).directive("paywall", paywall).mount('#app')
